import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-[720px] mx-auto px-6 md:px-10 py-20 fade-up" data-testid="payment-cancel-page">
      <div className="tag-red">Cancelled</div>
      <h1 className="font-display text-6xl mt-2">No harm done.</h1>
      <p className="font-body mt-4 opacity-80">Your card was not charged. The record is still waiting for you.</p>
      <div className="mt-8 flex gap-3">
        <Link to="/shop" className="btn-ink" data-testid="cancel-back-shop">Back to shop</Link>
        <Link to="/" className="btn-outline">Home</Link>
      </div>
    </div>
  );
}
